import Colors from "../../utils/Colors";


class ToImageStyleData {
    constructor(
        color = Colors.white,
        titleColor = 0xF68C37,//Colors.black,
        subtitleColor = Colors.black80, 
        textColor = Colors.black60,
        titleDesColor = Colors.black60,
        width = 1440,
        height = 1926,
        horizontalRatio = 0.06,
        verticalRatio = 0.16) {

        this.color = color; //背景颜色
        this.titleColor = titleColor;
        this.subtitleColor = subtitleColor;
        this.textColor = textColor;
        this.titleDesColor = titleDesColor;

        this.width = width;
        this.height = height;
        this.horizontalRatio = horizontalRatio;
        this.verticalRatio = verticalRatio;
    }

    getHorizontalMargin() {
        return this.width * this.horizontalRatio
    }

    getVerticalMargin() {
        return this.height * this.verticalRatio
    }

    getTitleUnderlineColor() {
        return 0xFFEC64;
    }
}

export default  ToImageStyleData